import { ComponentChildren, JSX } from 'preact'
import { useRef } from 'preact/hooks'
import classnames from 'classnames'
import { ActionType, BlockType, TBlockProps } from '@gsc/types'
import genUID from '../../../shared/uid'
import { previewProps } from '../../preview'
import { createEvent, shouldIgnoreEvents } from '../../helpers/events'
import { useComponentStyle } from '../Style'
import { useActions } from '../useActions'

interface Props extends TBlockProps<BlockType.Group> {
  children: ComponentChildren
}

export const Group = ({ children, actions = [], ...props }: Props): JSX.Element => {
  const { current: origin } = useRef(genUID())
  const processActions = useActions()
  const { classes } = useComponentStyle('group', props)
  const className = classnames(classes, { clickable: actions.length > 0 })

  const handleClick = async (e: MouseEvent) => {
    const target = e.target as HTMLElement
    if (!actions.length || shouldIgnoreEvents(target)) {
      return
    }

    e.preventDefault()
    e.stopPropagation()

    await processActions(actions, origin)

    const shouldSubmit = actions.some(a => a.type === ActionType.Submit)
    if (shouldSubmit) {
      // Find the closest form and trigger submit
      const form = target.closest('form')
      if (form) {
        form.dispatchEvent(createEvent('submit'))
      }
    }
  }

  return (
    <div className={className} onClick={handleClick} {...previewProps(BlockType.Group, props.id)}>
      {children}
    </div>
  )
}
